export default angular.module("decimalPlacesDirective", [])
  .directive("decimalPlaces", function () {
    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, ngModelCtrl) {
        let decimalPlaces = parseInt(attrs.decimalPlaces);

        ngModelCtrl.$parsers.push(function (value) {
          if (value === "") {
            return null;
          }
          return +value;
        });

        ngModelCtrl.$formatters.push(function(value) {
          if (value === null) {
            return "";
          }
          return +value;
        });

        ngModelCtrl.$render = function() {
          let number = parseFloat(ngModelCtrl.$viewValue);
          ngModelCtrl.$viewValue = isNaN(number)? "": number.toFixed(decimalPlaces);
          element.val(ngModelCtrl.$viewValue);
        };

        element.on('blur', function() {
          ngModelCtrl.$setViewValue(element.val());
          ngModelCtrl.$render();
          if (element.val() === "") {
            ngModelCtrl.$setViewValue(null);
            ngModelCtrl.$render();
          }
        });
      },
    };
  })
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/decimal-places.directive.js
 **/